import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  PackageSizeGrid,
  ColumnHeading,
  StyledTextField,
  PackageSizeError,
  StyledWrapper,
  Information,
  InformationContainer,
  Options,
  Option,
} from './package-size-and-weight.component.styles'
import {
  Body,
  SmallText,
} from 'ggx-componentlibrary/design/typography/typography.styles'
import Size1Image from './assets/size-1.svg'
import Size2Image from './assets/size-2.svg'
import Size3Image from './assets/size-3.svg'
import Size4Image from './assets/size-4.svg'
import Size5Image from './assets/size-5.svg'
import Size6Image from './assets/size-6.svg'

const PackageSizeAndWeight = ({
  length,
  width,
  height,
  weight,
  package_size_error: packageSizeError,
}) => {
  const [t] = useTranslation()

  const allInputsTouched =
    length.meta.touched && width.meta.touched && height.meta.touched
  const allInputsDirty =
    length.meta.dirty && width.meta.dirty && height.meta.dirty

  const error =
    (allInputsTouched || allInputsDirty) && packageSizeError.meta.error
  const hasWeightError = !!(weight.meta.touched && weight.meta.error)
  const hasPackageSizeError = !!packageSizeError.meta.error

  const preventEnteringDecimalOrHyphen = event => {
    if (event.key === '-' || event.key === '.') {
      event.preventDefault()
    }
  }

  const addExtraMargin =
    (allInputsTouched || allInputsDirty) &&
    hasPackageSizeError &&
    !hasWeightError
  const [selectedOption, setSelectedOption] = useState(1)
  const selectOption = value => {
    setSelectedOption(value)
    const packageSize = [
      ['20', '20', '10'],
      ['30', '30', '30'],
      ['40', '40', '40'],
      ['50', '50', '50'],
      ['60', '60', '60'],
      ['', '', ''],
    ][value - 1]
    length.input.onChange(packageSize[0])
    width.input.onChange(packageSize[0])
    height.input.onChange(packageSize[0])
  }

  console.log(length.meta, width.meta, height.meta)
  return (
    <StyledWrapper>
      <Options>
        <Option selected={selectedOption === 1} onClick={() => selectOption(1)}>
          <Size1Image />
          <Body typographyStyles="mb-none">{t('package_size__20')}</Body>
        </Option>
        <Option selected={selectedOption === 2} onClick={() => selectOption(2)}>
          <Size2Image />
          <Body typographyStyles="mb-none">{t('package_size__30')}</Body>
        </Option>
        <Option selected={selectedOption === 3} onClick={() => selectOption(3)}>
          <Size3Image />
          <Body typographyStyles="mb-none">{t('package_size__40')}</Body>
        </Option>
        <Option selected={selectedOption === 4} onClick={() => selectOption(4)}>
          <Size4Image />
          <Body typographyStyles="mb-none">{t('package_size__50')}</Body>
        </Option>
        <Option selected={selectedOption === 5} onClick={() => selectOption(5)}>
          <Size5Image />
          <Body typographyStyles="mb-none">{t('package_size__60')}</Body>
        </Option>
        <Option selected={selectedOption === 6} onClick={() => selectOption(6)}>
          <Size6Image />
          <Body typographyStyles="mb-none">{t('package_size__custom')}</Body>
        </Option>
      </Options>
      {selectedOption === 6 ? (
        <>
          <PackageSizeGrid>
            <ColumnHeading>{t('label__length')}</ColumnHeading>
            <ColumnHeading>{t('label__width')}</ColumnHeading>
            <ColumnHeading>{t('label__height')}</ColumnHeading>
          </PackageSizeGrid>
          <PackageSizeGrid>
            <StyledTextField
              showErrorWhenDirty
              data-testid="package-size-length-field"
              showSuffix={t('suffix__cm')}
              input={length.input}
              meta={length.meta}
              type="number"
              onKeyPress={preventEnteringDecimalOrHyphen}
            />
            <StyledTextField
              showErrorWhenDirty
              data-testid="package-size-width-field"
              showSuffix={t('suffix__cm')}
              input={width.input}
              meta={width.meta}
              type="number"
              onKeyPress={preventEnteringDecimalOrHyphen}
            />
            <StyledTextField
              showErrorWhenDirty
              data-testid="package-size-height-field"
              showSuffix={t('suffix__cm')}
              input={height.input}
              meta={height.meta}
              type="number"
              onKeyPress={preventEnteringDecimalOrHyphen}
            />
          </PackageSizeGrid>
          {error && <PackageSizeError>{error}</PackageSizeError>}
          <SmallText typographyStyles="mt-xs mb-m">
            {t('helper__lwh_single_limit', { singleSideDimension: 120 })} <br />
            {t('helper__lwh_sum_limit', { total: 180 })}
          </SmallText>
        </>
      ) : null}
      <PackageSizeGrid>
        <ColumnHeading>{t('label__weight')}</ColumnHeading>
      </PackageSizeGrid>
      <PackageSizeGrid>
        <StyledTextField
          data-testid="package-size-weight-field"
          showSuffix={t('suffix__kg')}
          input={weight.input}
          meta={weight.meta}
          type="number"
          onKeyPress={preventEnteringDecimalOrHyphen}
        />
      </PackageSizeGrid>
      <InformationContainer addExtraMargin={addExtraMargin}>
        <Information>{t('helper__weight_limit', { weight: 20 })}</Information>
      </InformationContainer>
    </StyledWrapper>
  )
}

PackageSizeAndWeight.propTypes = {
  length: PropTypes.object,
  width: PropTypes.object,
  height: PropTypes.object,
  weight: PropTypes.object,
  package_size_error: PropTypes.object,
}

export { PackageSizeAndWeight }
